import * as React from 'react';
import * as _ from 'lodash';
import { MaterialsFiltersContainer } from '../../StoneSetup/materialsFilter';
export default function (props, context) {
    function onClick1() {
        props.showAssignPopup(true);
    }
    function onClick2() {
        props.markAllFeaturesChecked(true);
    }
    function onClick3() {
        props.markAllFeaturesChecked(false);
    }
    function onClick4() {
        props.collapseFeaturesFilters(!props.areFeaturesFiltersCollapsed);
    }
    return React.createElement('div', { 'className': 'app-content-header app-content-header--buttons app-content-header--lined app-content-header--fixed' }, React.createElement('div', { 'className': 'app-content-header--buttons-left' }, React.createElement('button', {
        'className': 'ui-button4 ui-button4--green',
        'onClick': onClick1.bind(this)
    }, React.createElement('span', { 'className': 'ui-button4-icon ui-button-icon--arrow-down' }), React.createElement('span', {}, 'Assign Filters')), React.createElement('button', {
        'className': 'ui-button4 ui-button4--blue ui-button4--large',
        'style': {
            width: 'auto',
            padding: '0 10px'
        },
        'onClick': onClick2.bind(this)
    }, 'Select All (current page only)'), React.createElement('button', {
        'className': 'ui-button4 ui-button4--blue ui-button4--large',
        'style': {
            width: 'auto',
            padding: '0 10px'
        },
        'onClick': onClick3.bind(this)
    }, 'Deselect All (current page only)')), React.createElement('div', { 'className': 'app-content-header--buttons-right' }, React.createElement('div', { 'className': 'stone-button-wrapper stone-button-tuning' }, React.createElement('div', { 'className': 'stone-button-title' }, 'Filter By Any'), React.createElement('div', {
        'className': 'blue-button-inputs',
        'id': 'btnMaterials'
    }, 'Any Filter'), React.createElement(MaterialsFiltersContainer, {
        'button': 'btnMaterials',
        'expanded': false,
        'type': 'materials',
        'filterName': 'Any Filter',
        'hideMarkUpDown': true,
        'filters': props.allOtherFilters,
        'handleFilterClick': props.handleNonColorFilterClick
    })), React.createElement('div', { 'className': 'stone-button-wrapper stone-button-tuning' }, React.createElement('div', { 'className': 'stone-button-title' }, 'Filter By Color'), React.createElement('div', {
        'className': 'blue-button-inputs',
        'id': 'btnColors'
    }, 'Color'), React.createElement(MaterialsFiltersContainer, {
        'button': 'btnColors',
        'expanded': false,
        'type': 'colors',
        'filterName': 'Color',
        'filters': props.colorFilters,
        'handleFilterClick': props.handleColorFilterClick
    })), React.createElement('button', {
        'className': 'ui-button4 ui-button4--blue ui-button4--large',
        'onClick': onClick4.bind(this)
    }, '\r\n      Collapse Filters\r\n    ')));
}